import { Upload as UpladAntd } from 'antd';
import styled from 'styled-components';

export const CustomButton = styled.div`
    margin-bottom: 24px;
`;
